module.exports = __webpack_public_path__ + "static/media/stars.08a9b19a.svg";